// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FavoriteButton_favorite-btn__h5-Fb {
  text-transform: uppercase !important;
}
.FavoriteButton_favorite-btn--simple__GytN3 {
  min-width: auto !important;
  padding: 8px !important;
  border-radius: 4px !important;
}
.FavoriteButton_favorite-btn--simple__GytN3 .MuiButton-endIcon {
  margin: 0 !important;
}

.FavoriteButton_login-modal__8vC-6 {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}`, "",{"version":3,"sources":["webpack://./src/Explore/Components/FavoriteButton/FavoriteButton.module.scss"],"names":[],"mappings":"AAAA;EACE,oCAAA;AACF;AACE;EACE,0BAAA;EACA,uBAAA;EACA,6BAAA;AACJ;AACI;EACE,oBAAA;AACN;;AAIA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AADF","sourcesContent":[".favorite-btn {\n  text-transform: uppercase !important;\n\n  &--simple {\n    min-width: auto !important;\n    padding: 8px !important;\n    border-radius: 4px !important;\n\n    :global(.MuiButton-endIcon) {\n      margin: 0 !important;\n    }\n  }\n}\n\n.login-modal {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"favorite-btn": `FavoriteButton_favorite-btn__h5-Fb`,
	"favorite-btn--simple": `FavoriteButton_favorite-btn--simple__GytN3`,
	"login-modal": `FavoriteButton_login-modal__8vC-6`
};
export default ___CSS_LOADER_EXPORT___;
